export const err = "users/err";
export const req = "users/req";
export const res = "users/res";
export const create = "users/create";
export const createApi = "users/create/api";
export const createRes = "users/create";
